<template>
  <el-input
    v-model="searchInput"
    class="w-50 m-2"
    placeholder="｜输入关键词"
    :suffix-icon="Search"
    input-style="{width:240px;height:42px;background:#222531;border:1px solid #555555;border-radius:34px;color:#fff;}"
    @change="handleClick"
  />
</template>
<script lang="ts" >
import { ref, defineComponent, watchEffect } from "vue";
import { Search } from "@element-plus/icons-vue";
import { useRouter, useRoute } from "vue-router";
export default defineComponent({
  name: "search",
  setup() {
    const searchInput = ref("");
    const searchName = ref("");
    const router = useRouter();
    watchEffect(() => {
      searchName.value = searchInput.value;
    });
    const handleClick = (): void => {
      router.push({
        path: "/search",
        name: "search",
        query: {
          search_name: searchName.value,
          search_type: 0,
          search_active: "all",
        },
      });
    };
    return {
      searchInput,
      handleClick,
      Search,
    };
  },
});
</script>

<style lang="scss">
.el-input__inner:focus {
  border-color: #fff;
}
</style>

